import type { GoalRentSummary } from "web_myplann/Goals/Types/GoalRentSummary";
import type { GoalSummaryFormatOptions } from "web_myplann/Goals/Types/GoalSummary";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { joinTruthy } from "web_myplann/Shared/Utils/textFormatters";

const RentResources = Resources.Goals.Detail.Summary.Rent;

export const formatGoalRentLabel = (
	rent: GoalRentSummary,
	{ currencyCode, t, formatAmount }: GoalSummaryFormatOptions,
): string =>
	joinTruthy(
		[
			t(RentResources.label),
			t(rent.isPerpetual ? RentResources.perpetual : RentResources.toZero),
			joinTruthy(
				[
					t(RentResources.monthly, {
						amount: formatAmount(rent.monthlyRent, currencyCode),
					}),
					!rent.isPerpetual &&
						t(RentResources.duration, { count: rent.rentYears }),
				],
				" ",
			),
		],
		" · ",
	);
